'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import Raven from 'raven-js';
import { NavMarker } from 'react-rhumb';
import BadRequestError from './BadRequestError';
import MissingContentError from './MissingContentError';
import ForbiddenError from './ForbiddenError';

const ConditionalWrapper = ({
  condition,
  wrapper,
  children
}) => condition ? wrapper(children) : children;

const ApiError = ({
  className,
  error,
  marker404,
  marker403,
  markerDefault,
  resetLink
}) => {
  if (error.status === 404) {
    return /*#__PURE__*/_jsx(ConditionalWrapper, {
      condition: marker404,
      wrapper: children => /*#__PURE__*/_jsx(NavMarker, {
        name: marker404,
        children: children
      }),
      children: /*#__PURE__*/_jsx(MissingContentError, {
        className: className
      })
    });
  }

  if (error.status === 403) {
    return /*#__PURE__*/_jsx(ConditionalWrapper, {
      condition: marker403,
      wrapper: children => /*#__PURE__*/_jsx(NavMarker, {
        name: marker403,
        children: children
      }),
      children: /*#__PURE__*/_jsx(ForbiddenError, {
        className: className
      })
    });
  }

  Raven.captureException(error);
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: markerDefault,
    wrapper: children => /*#__PURE__*/_jsx(NavMarker, {
      name: markerDefault,
      children: children
    }),
    children: /*#__PURE__*/_jsx(BadRequestError, {
      className: className,
      resetLink: resetLink
    })
  });
};

ApiError.defaultProps = {
  error: {
    status: 404
  }
};
ApiError.propTypes = {
  className: PropTypes.string,
  error: PropTypes.shape({
    status: PropTypes.number,
    message: PropTypes.string,
    responseJSON: PropTypes.string
  }).isRequired,
  marker403: PropTypes.string,
  marker404: PropTypes.string,
  markerDefault: PropTypes.string,
  resetLink: PropTypes.string
};
export default ApiError;